import { ContentDisplay } from "@shared/src/components/common/misc/ContentDisplay";
import { Chip } from "@shared/src/components/ui/chip";

export interface AdvertisersTermsProps {
  message: string;
  tags: string[];
}

export function AdvertisersTerms({ message, tags }: AdvertisersTermsProps) {
  return (
    <ContentDisplay
      label="Advertisers Terms"
      content={message}
      containerClassName="border-2 border-border-secondary"
      bottomComponents={
        <div className="flex gap-2 items-center overflow-x-auto custom-scrollbar">
          {tags.map(tag => (
            <Chip
              key={tag}
              variant="secondary"
              size="sm"
              className="flex items-center gap-1 text-micro bg-surfaces-bg-secondary"
            >
              (i)
              <p className="text-micro">{tag}</p>
            </Chip>
          ))}
        </div>
      }
    />
  );
}
